var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      class: `${_vm.tipografia} ${_vm.cor}--text text--darken-1 text-no-wrap my-2`,
    },
    [_vm._v(" " + _vm._s(_vm.texto) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }